module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SMS"
  }, [_c('div', {
    staticClass: "SMS-header"
  }, [_c('div', [_vm._v("短信管理")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "SMS-main"
  }, [_c('el-form', {
    ref: "ruleFormRef",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学校"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "display": "flex",
      "line-height": "36px"
    },
    model: {
      value: (_vm.ruleForm.applicableCampus),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "applicableCampus", $$v)
      },
      expression: "ruleForm.applicableCampus"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0,
      "disabled": !_vm.isOperation
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": !_vm.isOperation
    }
  }, [_vm._v("部分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.ruleForm.applicableCampus ? '应用学校' : '屏蔽学校',
      "required": _vm.ruleForm.applicableCampus ? true : false,
      "prop": "smsCampus"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "请输入学校",
      "remote-method": _vm.remoteMethod,
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.schoolData),
      callback: function($$v) {
        _vm.schoolData = $$v
      },
      expression: "schoolData"
    }
  }, _vm._l((_vm.schoolList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.isOperation
    },
    on: {
      "click": _vm.onAddSchools
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.ruleForm.smsCampus), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "dialog-item"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.onDelSchools(item.value)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n          共计" + _vm._s(_vm.ruleForm.smsCampus.length) + "所学校\n        ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入学年份"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择入学年份",
      "filterable": "",
      "multiple": "",
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.caid),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "caid", $$v)
      },
      expression: "ruleForm.caid"
    }
  }, _vm._l((_vm.inYearDataSource), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生范围"
    }
  }, [_c('span', [_vm._v("共计" + _vm._s(_vm.ruleForm.studentNumber) + "位学生")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "编辑短信",
      "prop": "sendMessage"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入内容",
      "maxlength": 64,
      "show-word-limit": "",
      "disabled": !_vm.isOperation
    },
    model: {
      value: (_vm.ruleForm.sendMessage),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "sendMessage", $$v)
      },
      expression: "ruleForm.sendMessage"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isOperation) ? _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("发布")])], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e51063d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/SMSManage/Detail/index.vue
// module id = 1092
// module chunks = 0